var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#A0EE09",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7474 13.3356C24.5577 13.1221 24.2857 13 24 13C23.7144 13 23.4424 13.1222 23.2526 13.3356L15.2526 22.3358C15.0202 22.5972 14.9413 22.9611 15.0446 23.2953C15.1478 23.6295 15.4182 23.8855 15.7575 23.9703L23.7575 25.9701C23.9167 26.01 24.0833 26.01 24.2426 25.9701L32.2426 23.9701C32.5819 23.8853 32.8522 23.6293 32.9555 23.2951C33.0587 22.9609 32.9798 22.5971 32.7474 22.3356L24.7474 13.3356Z",
    fill: "#A0EE09"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7249 26.0257C17.2969 25.9269 16.8545 26.119 16.6345 26.4992C16.4145 26.8794 16.4683 27.3586 16.7672 27.6805L23.2673 34.6805C23.4566 34.8843 23.7221 35.0001 24.0001 35.0001C24.2782 35.0001 24.5437 34.8843 24.7329 34.6805L31.2328 27.6805C31.5317 27.3586 31.5855 26.8794 31.3655 26.4992C31.1455 26.119 30.7032 25.9269 30.2752 26.0257L24 27.4738L17.7249 26.0257Z",
    fill: "#A0EE09"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/transfer.faee9e5f7dcec3f9b9a249ac10d78145.svg";
export { ForwardRef as ReactComponent };